/**
 * Single source of truth for responsive screen breakpoints.
 *
 * Consumed by:
 *   - `apps/cinari-erp-client/tailwind.config.js` (Node, CommonJS require)
 *   - `libs/shared/src/lib/services/breakpoint.service.ts` (Angular, via .d.ts)
 *
 * Values are in pixels and represent mobile-first MIN-WIDTH thresholds:
 * a key matches when the viewport is greater than or equal to its value.
 *
 * Keep this file in sync with the typings in `breakpoints.d.ts`.
 */
const TAILWIND_BREAKPOINTS = Object.freeze({
  xs: 576,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
  '3xl': 1920
});

module.exports = { TAILWIND_BREAKPOINTS };
